module.exports = __webpack_public_path__ + "img/flights.d67f9cab.png";